"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Streams = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var common_core_1 = require("@moralisweb3/common-core");
var create_1 = require("./methods/create");
var update_1 = require("./methods/update");
var delete_1 = require("./methods/delete");
var getAll_1 = require("./methods/getAll");
var verifySignature_1 = require("./methods/verifySignature");
var addAddress_1 = require("./methods/addAddress");
var updateStatus_1 = require("./methods/updateStatus");
var logParser_1 = require("./methods/logParser");
var getAddresses_1 = require("./methods/getAddresses");
var deleteAddress_1 = require("./methods/deleteAddress");
var getById_1 = require("./methods/getById");
var common_streams_utils_1 = require("@moralisweb3/common-streams-utils");
var BASE_URL = 'https://api.moralis-streams.com';
var Streams = /** @class */ (function (_super) {
    __extends(Streams, _super);
    function Streams(core) {
        var _this = _super.call(this, Streams.moduleName, core, BASE_URL) || this;
        _this.add = (0, create_1.makeCreateStream)(_this.core, BASE_URL);
        _this.update = (0, update_1.makeUpdateStream)(_this.core, BASE_URL);
        _this.delete = (0, delete_1.makeDeleteStream)(_this.core, BASE_URL);
        _this.getAll = (0, getAll_1.makeGetStreams)(_this.core, BASE_URL);
        _this.getById = (0, getById_1.makeGetStreamById)(_this.core, BASE_URL);
        _this.updateStatus = (0, updateStatus_1.makeUpdateStreamStatus)(_this.core, BASE_URL);
        _this.addAddress = (0, addAddress_1.makeAddAddress)(_this.core, BASE_URL);
        _this.getAddresses = (0, getAddresses_1.makeGetAddresses)(_this.core, BASE_URL);
        _this.deleteAddress = (0, deleteAddress_1.makeDeleteAddress)(_this.core, BASE_URL);
        _this.getHistory = _this.createPaginatedFetcher(common_streams_utils_1.getHistoryOperation);
        _this.retry = _this.createFetcher(common_streams_utils_1.replayHistoryOperation);
        _this._getStats = _this.createFetcher(common_streams_utils_1.getStatsOperation);
        _this.getStats = function () { return _this._getStats({}); };
        _this.getStatsById = _this.createFetcher(common_streams_utils_1.getStatsByIdOperation);
        _this.setSettings = _this.createFetcher(common_streams_utils_1.setSettingsOperation);
        _this._readSettings = _this.createFetcher(common_streams_utils_1.getSettingsOperation);
        _this.readSettings = function () { return _this._readSettings({}); };
        _this.verifySignature = function (options) { return (0, verifySignature_1.makeVerifySignature)(_this.core)(options); };
        _this.parsedLogs = function (webhookData) { return (0, logParser_1.parseLog)(webhookData); };
        return _this;
    }
    Streams.create = function (core) {
        return new Streams(core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault());
    };
    Streams.prototype.setup = function () {
        // Nothing
    };
    Streams.prototype.start = function () {
        // Nothing
    };
    Streams.prototype.createFetcher = function (operation) {
        return new api_utils_1.OperationResolver(operation, BASE_URL, this.core).fetch;
    };
    Streams.prototype.createPaginatedFetcher = function (operation) {
        return new api_utils_1.PaginatedOperationResolver(operation, BASE_URL, this.core).fetch;
    };
    Streams.moduleName = 'streams';
    return Streams;
}(common_core_1.ApiModule));
exports.Streams = Streams;
//# sourceMappingURL=Streams.js.map